import { Controller } from "@hotwired/stimulus"

let tianzhenLoginChart;

export default class extends Controller {
  static targets = [ "chart" ];
  static values = { tzlcTime: Array, tzlcCount: Array, legendName: String };

  connect() {
    tianzhenLoginChart = echarts.init(this.chartTarget);

    const option = {
      title: {
        text: '软件使用统计',
        left: 'center',
        top: 0,
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {
        data: [this.legendNameValue],
        left: 'center',
        top: 36
      },
      grid: {
        left: '3%',
        right: '1%',
        top: 72,
        bottom: '20',
        containLabel: true
      },
      toolbox: {
        feature: {
          dataView: {},
          saveAsImage: {
              pixelRatio: 2
          }
        }
      },
      xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.tzlcTimeValue
      },
      yAxis: {
        type: 'value',
        max: function (value) {
          return value.max >= 15 ? value.max : 15;
        }
      },
      series: [{
        name: this.legendNameValue,
        data: this.tzlcCountValue,
        type: 'line',
        areaStyle: {}
      }]
    };

    tianzhenLoginChart.setOption(option);
  }

  layout() {
    tianzhenLoginChart.resize();
  }

  disconnect() {
    tianzhenLoginChart.dispose();
  }
}
